import { render, staticRenderFns } from "./ProteinSearch.vue?vue&type=template&id=3a9deeee&scoped=true"
import script from "./ProteinSearch.vue?vue&type=script&lang=js"
export * from "./ProteinSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9deeee",
  null
  
)

export default component.exports